import { RowsAdmin } from "../../admin/RowsAdmin";
import { SYNONYM_FIELDS } from "../../admin/fields";

export function SynonymsAdmin() {
  return (
    <RowsAdmin title="Synonyms" versionType="synonym" apiBase="/api/admin/kb/synonyms" rowsKey="synonyms" listKey="kb-synonyms"
      intro="When a rep types the term, search also looks for each expansion. Add common misspellings here too (medicade → medicaid): a synonym term is never corrected to another word."
      fields={SYNONYM_FIELDS} describe={(r) => ({ primary: String(r.term), secondary: `→ ${String(r.expansion)}` })} />
  );
}
